/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import axios from 'axios';
import _ from 'lodash';
import * as actionTypes from './ActionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';

export const resetReduxDL = (payload) => {
  return {
    type: actionTypes.RESET_REDUX_DL,
  };
};

export const dispatchSearchTabData = (data) => ({
  type: actionTypes.SEARCH_TAB_DATA_DL,
  searchTabData: data,
});

export const handleErrorMessages = (data) => ({
  type: actionTypes.HANDLE_ERROR_MESSAGE_FOR_DL,
  errorMessagesInRedux: data,
});

export const dispatchPlanTypeFilterData = (data) => ({
  type: actionTypes.GET_PLAN_TYPE_DATA_DL,
  checkbox: data,
});

export const dispatchTemplateTypeList = (data) => ({
  type: actionTypes.TEMPLATE_TYPE_LIST_DL,
  templateTypeList: data,
});

export const dispatchTemplateNameList = (data) => ({
  type: actionTypes.TEMPLATE_NAME_LIST_DL,
  templateNameList: data,
});
export const getCheckBoxValue = () => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      return dispatch(dispatchPlanTypeFilterData(response.data));
    })
    .catch((response) => {
      dispatch(dispatchPlanTypeFilterData([]));
    });
};
export const getTemplateType = () => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['TEMPLATE_TYPE_CD'],
    })
    .then((response) => {
      return dispatch(dispatchTemplateTypeList(response.data));
    })
    .catch((response) => {
      dispatch(dispatchTemplateTypeList([]));
    });
};

export const getTemplateName = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.TEMPLATE_NAME_LIST_DL, value)
    .then((response) => {
      return dispatch(dispatchTemplateNameList(response?.data?.letterTemplate));
    })
    .catch((response) => {
      dispatch(dispatchTemplateNameList([]));
    });
};

export const dispatchTempTableData = (data) => ({
  type: actionTypes.TEMP_LETTER_TABLE_DATA,
  tempLetterTableData: data,
});

export const getTempTableData = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.TEMP_TABLE_DATA, value)
    .then((response) => {
      return dispatch(dispatchTempTableData(response?.data));
    })
    .catch((response) => {
      dispatch(
        dispatchTempTableData({
          message: 'FAIL',
          status: '000',
          letterHeader: [],
        })
      );
    });
};

export const getRebateFromInvoice = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_INVOICE_DETAILS_BY_INVOICE_NUM, value)
    .then((response) => {
      return response.data;
    })
    .catch((response) => {
      return [];
    });
};

export const dispatchFirstError = (data) => ({
  type: actionTypes.HANDLE_FIRST_ERROR,
  firstErrorBool: data,
});

export const getCommonDropdownList = (value) => {
  return axios
    .post(serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN, { planType: value })
    .then((response) => {
      return response.data;
    })
    .catch((response) => {
      return [];
    });
};

export const dispatchManufacturerData = (data) => ({
  type: actionTypes.GET_MANUFACTURER_DATA_DL,
  manufacturerList: data,
});

export const getManufacturerList = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.MFG_FOR_DISPLAY_LETTER, value)
    .then((response) => {
      return dispatch(
        dispatchManufacturerData(
          response.data && response.data.displayLetterMfgGridVO
        )
      );
    })
    .catch(() => {
      dispatch(dispatchManufacturerData([]));
    });
};

export const setMfgSelected = (data) => {
  return {
    type: actionTypes.MFG_SELECTED_DL,
    mfgSelected: data,
  };
};

export const setCreateTemplateExtraState = (data) => ({
  type: actionTypes.GET_DISPLAY_TEMPLATE_EXTRA_STATE,
  extraState: data,
});

export const dispatchFetchCreateLetterDetailData = (data) => ({
  type: actionTypes.FETCH_CREATE_LETTER_DETAIL_DATA_DISPLAY,
  createLetterDetail: data,
});

export const updateCreateLetterDetailData = (data) => (dispatch) => {
  dispatch(dispatchFetchCreateLetterDetailData(data));
};

export const fetchCreateLetterDetailData = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.CREATE_LETTER_DETAIL_PREVIEW, value.request)
    .then((response) => {
      let data = [];
      if (response.data && response.data.message === 'SUCESS') {
        data = response.data.data || response.data.printPreviewVO;
      }
      data = {
        ...response.data,
        result: {
          searchData: value.searchData,
          letterDetail: data,
          headerDetail: value.headerDetail,
        },
      };
      return dispatch(dispatchFetchCreateLetterDetailData(data));
    })
    .catch((response) => {
      dispatch(
        dispatchFetchCreateLetterDetailData({
          message: 'FAIL',
          status: '000',
          result: null,
        })
      );
    });
};

export const fetchCreateLetterDetailByLetterIDData = (value) => (dispatch) => {
  const finalData = {
    ...value.preData,
  };
  return axios
    .post(serviceEndPoint.GET_LETTER_DETAIL_BY_LETTER_ID, value.request)
    .then((response) => {
      if (response.data && response.data.message === 'SUCESS') {
        finalData.headerDetail =
          response.data.data || response.data.letterHeaderDetailsVO;
      }
      return dispatch(dispatchFetchCreateLetterDetail(finalData));
    })
    .catch((response) => {
      dispatch(dispatchFetchCreateLetterDetail(finalData));
    });
};

// get extra detail with invoice number
export const dispatchGetInvoiceDetailsByInvoiceNum = (data) => ({
  type: actionTypes.GET_INVOICE_DETAILS_BY_INVOICE_NUM_DISPLAY,
  invoiceDetail: data,
});

export const updateInvoiceDetailsByInvoiceNum = (data) => (dispatch) => {
  dispatch(dispatchGetInvoiceDetailsByInvoiceNum(data));
};

export const getInvoiceDetailsByInvoiceNum = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_INVOICE_DETAILS_BY_INVOICE_NUM, value)
    .then((response) => {
      let newData = [];
      if (
        response.data &&
        response.data.message === 'SUCESS' &&
        response.data.status === '001'
      ) {
        newData = response.data.data;
      }
      return dispatch(dispatchGetInvoiceDetailsByInvoiceNum(newData));
    })
    .catch((response) => {
      dispatch(dispatchGetInvoiceDetailsByInvoiceNum([]));
    });
};

// set data after save
export const dispatchSaveCreateLetter = (data) => ({
  type: actionTypes.SAVE_CREATE_LETTER_DATA_DISPLAY,
  saveCreateLetterData: data,
});

export const updateCreateLetterSaveApi = (data) => (dispatch) => {
  dispatch(dispatchSaveCreateLetter(data));
};

// Update send date after send
export const saveCreateTemplate = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.UPDATE_SENT_DATE, value)
    .then((response) => {
      return dispatch(dispatchSaveCreateLetter(response.data));
    })
    .catch((response) => {
      dispatch(dispatchSaveCreateLetter({ message: 'FAIL', status: '000' }));
    });
};

// Save letter after click on Save btn
export const saveDisplayLetterAPI = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.SAVE_DISPLAY_LETTER, value)
    .then((response) => {
      return dispatch(dispatchSaveCreateLetter(response.data));
    })
    .catch((response) => {
      dispatch(dispatchSaveCreateLetter({ message: 'FAIL', status: '000' }));
    });
};

// get all data in detail page after call api or not
export const dispatchFetchCreateLetterDetail = (data) => ({
  type: actionTypes.FETCH_CREATE_LETTER_DETAIL_DISPLAY,
  detailScrenData: data,
});

export const updateCreateLetterDetail = (data) => (dispatch) => {
  dispatch(dispatchFetchCreateLetterDetail(data));
};

export const fetchCreateLetterDetail = (value) => (dispatch) => {
  const finalData = {
    searchData: value.searchData,
    letterDetail: [],
    headerDetail: value.headerDetail,
  };
  return axios
    .post(serviceEndPoint.CREATE_LETTER_DETAIL_PREVIEW, value.request)
    .then((response) => {
      if (response.data && response.data.message === 'SUCESS') {
        finalData.letterDetail =
          response.data.data || response.data.printPreviewVO;
      }
      return dispatch(dispatchFetchCreateLetterDetail(finalData));
    })
    .catch((response) => {
      dispatch(dispatchFetchCreateLetterDetail(finalData));
    });
};

// get to mail id
export const dispatchGetToMailID = (data) => ({
  type: actionTypes.GET_TO_MAIL_ID_DISPLAY,
  toMailId: data,
});

// update to mail id value
export const updateToMailIDCreateTemplate = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.UPDATE_TO_MAIL_ID, value)
    .then((response) => {
      let newData = '';
      if (
        response.data &&
        response.data.message === 'SUCESS' &&
        response.data.status === '001'
      ) {
        newData = response.data.data || response.data.updatedMailId;
      }
      const data = { isUpdate: true, toMailId: newData };
      return dispatch(dispatchGetToMailID(data));
    })
    .catch((response) => {
      dispatch(dispatchGetToMailID([]));
    });
};

// get from mail id
export const dispatchGetFromMailID = (data) => ({
  type: actionTypes.GET_FROM_MAIL_ID_DISPLAY,
  payload: data,
});

export const getFromMailIDCreateTemplate = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_FROM_MAIL_ID, value)
    .then((response) => {
      let newData = '';
      if (
        response.data &&
        response.data.message === 'SUCESS' &&
        response.data.status === '001'
      ) {
        newData = response.data.data || response.data.fromMailId;
      }
      const data = { isUpdate: false, fromMailId: newData };
      return dispatch(dispatchGetFromMailID(data));
    })
    .catch((response) => {
      dispatch(dispatchGetFromMailID([]));
    });
};

// update from mail id value
export const updateFromMailIDCreateTemplate = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.UPDATE_FROM_MAIL_ID, value)
    .then((response) => {
      let newData = '';
      if (
        response.data &&
        response.data.message === 'SUCESS' &&
        response.data.status === '001'
      ) {
        newData = response.data.data || response.data.updatedMailId;
      }
      const data = { isUpdate: true, fromMailId: newData };
      return dispatch(dispatchGetFromMailID(data));
    })
    .catch((response) => {
      dispatch(dispatchGetFromMailID([]));
    });
};

// all send email with letest content
export const dispatchSendMailForLetter = (data) => ({
  type: actionTypes.SEND_LETTER_BY_EMAIL_DISPLAY,
  sendMail: data,
});
export const sendMailWithCreateTemplate = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.SEND_LETTER_BY_EMAIL, value)
    .then((response) => {
      return dispatch(dispatchSendMailForLetter(response.data));
    })
    .catch(() => {
      dispatch(
        dispatchSendMailForLetter({
          message: 'FAIL',
          status: '000',
          actionFlag: 'Email Send Fail.',
        })
      );
    });
};

// get print pdf
export const dispatchPrintPreview = (data) => ({
  type: actionTypes.GET_PRINT_PREVIEW_DISPLAY,
  pdfPreview: data,
});

export const getPrintPreview = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_PDF_PRINT_PREVIEW, value, {
      responseType: 'arraybuffer',
      headers: {
        Accept: 'application/octet-stream',
      },
    })
    .then((response) => {
      const newData = response.data;
      return dispatch(dispatchPrintPreview(newData));
    })
    .catch((response) => {
      dispatch(dispatchPrintPreview([]));
    });
};

// get draft pdf
export const dispatchPrintDraftPDFPreview = (data) => ({
  type: actionTypes.GET_PREVIEW_DRAFT_PDF_DISPLAY,
  pdfDraftPreview: data,
});

export const getPrintDraftPDFPreview = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.PREVIEW_DRAFT_PDF, value, {
      responseType: 'arraybuffer',
      headers: {
        Accept: 'application/octet-stream',
      },
    })
    .then((response) => {
      const newData = response.data;
      return dispatch(dispatchPrintDraftPDFPreview(newData));
    })
    .catch((response) => {
      dispatch(dispatchPrintDraftPDFPreview(''));
    });
};

export const clearDisplayLetterPageDispatch = (val) => {
  return { type: actionTypes.DISPLAY_LETTER_CLEAR_REDUX_DATA, payload: val };
};

export const clearDisplayLetterPage = () => (dispatch, getState) => {
  const reduxObj = getState()?.sharedState?.LetterReducer;
  const updateTabs =
    JSON.parse(localStorage.getItem('tabItemsData')) === null
      ? []
      : JSON.parse(localStorage.getItem('tabItemsData'));
  let newObj1 = {};
  if (!_.isEmpty(updateTabs)) {
    const newObj = _.cloneDeep(reduxObj);
    if (
      updateTabs.filter(
        (x) => x.navTo === '/letter' || x.navTo === '/displayLetterDetail'
      ).length !== 0
    ) {
      newObj1 = newObj;
    } else {
      newObj1 = [];
    }
  } else {
    newObj1 = [];
  }

  dispatch(clearDisplayLetterPageDispatch(newObj1));
};
